export default __webpack_public_path__ + "static/media/bici.0375731b.svg";